export function isEmoji(char: string): boolean {
    const ranges = [
        '\ud83c[\udf00-\udfff]', // U+1F300 to U+1F3FF
        '\ud83d[\udc00-\ude4f]', // U+1F400 to U+1F64F
        '\ud83d[\ude80-\udeb9]', // U+1F680 to U+1F6FF
        '[\ud83e-\udd00]',
    ];
    return !!char.match(ranges.join('|'));
}